module.exports = __webpack_public_path__ + "img/shapes.8f46fc22.svg";